<header class="mb-auto">
    <div>
        <h3 class="float-md-start mb-0"><span class="manual">Manual</span>Radar</h3>
        <nav class="nav nav-masthead justify-content-center float-md-end">
            <a class="nav-link fw-bold py-1 px-0" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/']">
                <i class="fas fa-home me-1"></i>Home
            </a>
            <a class="nav-link fw-bold py-1 px-0" routerLinkActive="active" [routerLink]="['/features']">
                <i class="fas fa-list-alt me-1"></i>Funktionen
            </a>
            <a class="nav-link fw-bold py-1 px-0" routerLinkActive="active" [routerLink]="['/price']">
                <i class="fas fa-euro-sign me-1"></i>Preise
            </a>
            <a class="nav-link fw-bold py-1 px-0" routerLinkActive="active" [routerLink]="['/demo']">
                <i class="fas fa-qrcode me-1"></i>Demo
            </a>
            <a class="nav-link fw-bold py-1 px-0" routerLinkActive="active" [routerLink]="['/imprint']">
                <i class="fas fa-envelope me-1"></i>Kontakt
            </a>
        </nav>
    </div>
</header>
